import { useWYSIWYGContext } from '../contexts/WYSIWYGContext';

// We follow the same format of changing content and intial value and rendering tiny to false
// in WYSIWYG editor
export const useReplaceContent = () => {
  const { setInitValue, onChange, setRenderTiny } = useWYSIWYGContext();
  return (value: string) => {
    onChange(value);
    setInitValue(value);
    setRenderTiny(false);
  };
};
